import { AiSuggestionReview } from '../../../index'
import { adminHttpClient } from '../../commons/adminHttpClient'
import { ReviewerAction } from './reviewerAction'

export type ReviewExpenseRequest = {
  expenseId: string
  overrideAmount?: number | null
  amountReviewStatus: ReviewerAction | null
  messageToEmployee: string
  messageToReviewer: string
  overrideServiceDate: string | null
  expenseTypeReviewStatus: ReviewerAction | null
  overrideExpenseTypeId: number | null
  purchasedDateReviewStatus: ReviewerAction | null
  ineligibleExpenseType: boolean
  reviewSectionEOBStatus: ReviewerAction | null
  isDuplicate: boolean
  overrideServiceProvider: string | null
  serviceProviderReviewStatus: ReviewerAction | null
  overrideFamilyMemberId: string | null
  familyMemberIdReviewStatus: ReviewerAction | null
  aiSuggestionReview: AiSuggestionReview
}

const reviewExpense = (values: ReviewExpenseRequest): Promise<any> => {
  return adminHttpClient.post('/DocReview/ReviewExpense', values)
}

export default reviewExpense
